import {
    createBrowserRouter
  } from "react-router-dom";
  import Home from "./routes/home";
  import About from './routes/about';
  // import Events from './routes/events';
  import Contact from './routes/contact';
import Mailing from "./routes/mailing";

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Home/>,
    },    
    {
      path: "/about",
      element: <About/>,
    },
    // {
    //   path: "/events",
    //   element: <Events/>,
    // },
    {
      path: "/contact",
      element: <Contact/>,
    },    {
      path: "/mailing",
      element: <Mailing/>,
    },
  ]);

  export default router